(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor(){ super(); }
    connectedCallback(){
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
      this.currentScrollTop = 0; this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight(){ document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback(){
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver(){
      let observer = new IntersectionObserver((entries, observer) => { this.headerBounds = entries[0].intersectionRect; observer.disconnect(); });
      observer.observe(this.header);
    }
    onScroll(){
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return; requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom){
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.preventReveal = false;
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top){
        this.header.classList.remove('scrolled-past-header'); requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide(){ if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }
    reveal(){ if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky','animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset(){ if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate');
    }
    closeMenuDisclosure(){ (this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu')).forEach(d => d.close()); }
    closeSearchModal(){ (this.searchModal = this.searchModal || this.header.querySelector('details-modal')).close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-home-faq"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var sections = document.querySelectorAll('.section-home-faq[data-section-type="home-faq"]');
      sections.forEach(function(root) {
        if (root.__faqInit) return;
        root.__faqInit = true;

        var items = root.querySelectorAll('.faq-item');
        // Only-one-open behavior
        items.forEach(function(item) {
          item.addEventListener('toggle', function() {
            if (item.open) {
              items.forEach(function(other) {
                if (other !== item && other.open) other.open = false;
              });
            }
          });
        });
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
    (function() {
      var sections = document.querySelectorAll('.section-testimonial-carousel[data-section-type="testimonial-carousel"]');
      sections.forEach(function(root) {
        if (root.__tcInit) return;
        root.__tcInit = true;

        var slides = Array.prototype.slice.call(root.querySelectorAll('.tc-slide'));
        var dots   = Array.prototype.slice.call(root.querySelectorAll('.tc-dot'));
        var prev   = root.querySelector('.tc-nav--prev');
        var next   = root.querySelector('.tc-nav--next');
        var stage  = root.querySelector('.tc-stage');

        if (!slides.length) return;

        var current = 0;
        var timer = null;
        var autoplay = root.getAttribute('data-autoplay') !== 'false';
        var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
        var paused = false;
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function go(idx) {
          idx = ((idx % slides.length) + slides.length) % slides.length;
          if (idx === current) return;
          slides[current].removeAttribute('data-active');
          slides[current].setAttribute('aria-hidden', 'true');
          slides[idx].setAttribute('data-active', 'true');
          slides[idx].setAttribute('aria-hidden', 'false');
          if (dots[current]) {
            dots[current].removeAttribute('data-active');
            dots[current].setAttribute('aria-selected', 'false');
          }
          if (dots[idx]) {
            dots[idx].setAttribute('data-active', 'true');
            dots[idx].setAttribute('aria-selected', 'true');
          }
          current = idx;
        }

        function start() {
          if (!autoplay || prefersReduced || paused) return;
          stop();
          timer = setInterval(function() { go(current + 1); }, interval);
        }

        function stop() {
          if (timer) { clearInterval(timer); timer = null; }
        }

        // Nav buttons
        if (prev) prev.addEventListener('click', function() { go(current - 1); stop(); start(); });
        if (next) next.addEventListener('click', function() { go(current + 1); stop(); start(); });

        // Dots
        dots.forEach(function(dot) {
          dot.addEventListener('click', function() {
            var idx = parseInt(dot.getAttribute('data-dot-index'), 10);
            if (!isNaN(idx)) { go(idx); stop(); start(); }
          });
        });

        // Pause on hover / focus
        [root, stage].forEach(function(el) {
          if (!el) return;
          el.addEventListener('mouseenter', function() { paused = true;  stop(); });
          el.addEventListener('mouseleave', function() { paused = false; start(); });
          el.addEventListener('focusin',    function() { paused = true;  stop(); });
          el.addEventListener('focusout',   function() { paused = false; start(); });
        });

        // Pause when tab not visible
        document.addEventListener('visibilitychange', function() {
          if (document.hidden) stop(); else start();
        });

        // Keyboard nav
        stage.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowLeft')  { e.preventDefault(); go(current - 1); stop(); start(); }
          if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); stop(); start(); }
        });

        // Touch swipe
        var touchStartX = null;
        stage.addEventListener('touchstart', function(e) {
          if (e.touches && e.touches.length) touchStartX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function(e) {
          if (touchStartX == null) return;
          var endX = (e.changedTouches && e.changedTouches[0]) ? e.changedTouches[0].clientX : touchStartX;
          var dx = endX - touchStartX;
          if (Math.abs(dx) > 40) {
            if (dx < 0) go(current + 1);
            else        go(current - 1);
            stop(); start();
          }
          touchStartX = null;
        }, { passive: true });

        start();
      });
    })();
  
  } catch(e) { console.error(e); }
})();
})();
